import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const reportRoutes = {
  name: 'report',
  path: 'report',
  component: () => import('./Report.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
